import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./novasenha.css";
import Imagens from "../../../components/IMAGESCOMPONENT/ImageComponent";

function NovaSenha() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const navigate = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    setErrorMessage("");
    setSuccessMessage("");

    const emailLimpo = email.trim();

    try {
      const response = await fetch(
        "https://app.eliandroalimentos.com.br/api/primeiro_acesso/nova-senha",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email: emailLimpo }),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        // 🔹 Tratamento de erros específicos da API
        if (data.error === "Email não cadastrado.") {
          setErrorMessage("O email informado não está cadastrado.");
        } else if (data.error === "Email ainda não possui primeiro acesso cadastrado.") {
          setErrorMessage(
            <>
              Ainda não existe{" "}
              <a href="/primeiro-acesso" className="novasenha-link">
                PRIMEIRO ACESSO
              </a>{" "}
              para este email.
            </>
          );
        } else if (data.error.includes("Serviço indisponível")) {
          setErrorMessage("Serviço indisponível no momento. Tente novamente mais tarde.");
        } else {
          setErrorMessage("Erro ao gerar nova senha.");
        }
      } else {
        // 🔹 Sucesso: confirma email e informa que a nova senha foi enviada
        setSuccessMessage(
          `Nova senha gerada e enviada para o e-mail: ${emailLimpo}`
        );
      }
    } catch (err) {
      console.error("Erro ao solicitar nova senha:", err);
      setErrorMessage("Serviço indisponível no momento. Tente novamente mais tarde.");
    } finally {
      setLoading(false);
    }
  }


  return (
    <div className="novasenha-wrapper">
      <div className="novasenha-card">
        <div className="novasenha-brand">
          <img src={Imagens.Logo}
            onClick={() => navigate("/")}
            style={{ cursor: "pointer" }}
            alt="Eliandro Alimentos" />
        </div>

        <form className="novasenha-form" onSubmit={handleSubmit}>
          {errorMessage && (
            <div className="novasenha-error">
              {errorMessage.includes("primeiro acesso") ? (
                <>
                  Ainda não existe{" "}
                  <a
                    href="/primeiro-acesso"
                    className="novasenha-link"
                  >
                    PRIMEIRO ACESSO
                  </a>{" "}
                  para este email.
                </>
              ) : (
                errorMessage
              )}
            </div>
          )}


          {successMessage && (
            <div className="novasenha-success">{successMessage}</div>
          )}

          <div className="novasenha-input-group">
            <label>Email</label>
            <div className="novasenha-input-wrapper">
              <input
                type="email"
                placeholder="seu@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
          </div>

          <button className="novasenha-button" disabled={loading}>
            {loading ? "Enviando..." : "Solicitar nova senha"}
          </button>
        </form>

        <div className="novasenha-footer">
          <button
            type="button"
            className="novasenha-link-button"
            onClick={() => navigate("/login")}
          >
            Voltar para o login
          </button>
        </div>
      </div>
    </div>
  );
}

export default NovaSenha;
